import {
	EX_REQUEST,
	EX_SUCCESS,
	EX_FAILURE,
	SET_ERROR,
} from '../../types'

const initialState = {
	hasError: false,
	isLoading: false,
	error: null,
}
export default (state = initialState, action) => {

	switch (action.type) {
		case EX_REQUEST:
			return {
				...state,
				isLoading: true,
				hasError: false,
				error: null,
			}
		case EX_SUCCESS:
			return {
				...state,
				isLoading: false,
				hasError: false,
				error: null,
			}
		case EX_FAILURE:
			let returnData = {
				...state,
				isLoading: false,
				hasError: true,
				error: action.payload.data,
			}
			return returnData
		case SET_ERROR:
			return {
				...state,
				hasError: action.hasError,
				error: action.error
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js